import './regular';
import './light';
import './solid';
import './sharp_solid';

import './icon.css';

import { icon, layer, parse, findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faBug } from '@fortawesome/pro-regular-svg-icons';

const DEFAULT_PREFIX = 'fas';

const resolveIconDefinition = (prefix, iconName) => {
    let definition = findIconDefinition({ prefix: prefix, iconName: iconName });
    
    if( !definition ) {
        console.error("Icon with prefix %s and name %s cannot be found", prefix, iconName);
        // use faBug for missing icons
        definition = faBug;
    }
    
    return definition;
}

const getBugIcon = () => icon(faBug).html[0];

const getIcon = (opts) => {
    let { iconName, prefix, transform, className } = opts;
        
    if( typeof opts === 'string' ) { 
        iconName = opts;
    }   
    
    if( typeof transform === 'string' ) {
        transform = parse.transform(transform)
    }
        
    const definition = resolveIconDefinition(prefix || DEFAULT_PREFIX, iconName);
    return icon(definition, {
                transform: transform,
                classes: [className]
            });
}

const getFaIcon = (opts) => {
    return getIcon(opts).html[0];
}

const getLayeredIcon = (options) => {
    const result = layer((push) => {
        for (let i = 0; i < options.length; i++) {
            push(getIcon(options[i]));
        }
    });

    const html = result.html;
    return html[0];
}

export {
    getFaIcon,
    getBugIcon,
    getLayeredIcon
}
